import Footer from "../Footer";
import Header from "../Header";
import { useState, useRef } from "react";
import "../styles/register.scss";
import { useNavigate } from "react-router-dom";
import DealTradingImg from "../images/Deal trading image.webp";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import "../styles/subscriptions.scss";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { FormControlLabel, Checkbox, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = await loadStripe("pk_live_aRr3qYrpVTbyNgBbB7t0jqiy");
// const stripePromise = await loadStripe("pk_test_HGDc5rMpzlE4NJvFygwF1zIW");

export default function Register() {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("eventId");
  const initialAttendeeData = {
    name: "",
    lastName: "",
    phone: "",
    email: "",
    eventId: parseInt(eventId),
    postcode: "",
    paidAmount: 49,
  };
  const scrollRef = useRef();
  const url = process.env.REACT_APP_API_URL;
  const [options, setOptions] = useState({});
  const [attendeeCount, setAttendeeCount] = useState(1);
  const [formData, setFormData] = useState([{ ...initialAttendeeData }]);
  const [formErrors, setFormErrors] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [tncs, setTncs] = useState(false);
  // alerts
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [alert, setAlert] = useState(false);
  const [disable, setDisable] = useState(false);

  const handleAlert = (message, severity, duration = 3000) => {
    setDisable(true);
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
    }, duration);
  };

  const handleCountChange = (e) => {
    const count = parseInt(e.target.value);
    setAttendeeCount(count);
    const newData = Array(count)
      .fill(null)
      .map(() => ({ ...initialAttendeeData }));
    setFormData(newData);
    setFormErrors([]);
    setFormSubmitted(false);
  };

  const handleInputChange = (index, field, value) => {
    const updatedFormData = [...formData];
    updatedFormData[index][field] = value;
    setFormData(updatedFormData);
  };

  const validateForms = () => {
    const errors = formData.map((attendee) => {
      let error = {};

      if (!attendee.name.trim()) {
        error.name = "First name is required";
      }

      if (!attendee.lastName.trim()) {
        error.lastName = "Last name is required";
      }

      if (!attendee.phone.trim()) {
        error.phone = "Phone number is required";
      }

      if (!attendee.email.trim() || !/\S+@\S+\.\S+/.test(attendee.email)) {
        error.email = "Valid email is required";
      }

      if (!attendee.postcode.trim()) {
        error.postcode = "Postcode is required";
      }

      return error;
    });

    setFormErrors(errors);
    return errors.every((error) => Object.keys(error).length === 0);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!tncs) {
      handleAlert("Please check terms & conditions");
    } else if (validateForms()) {
      console.log(formData);
      await axios
        .post(`${url}/psdt/secret`, { attendees: formData })
        .then((res) => {
          setOptions({ clientSecret: res.data.clientSecret });
          setFormSubmitted(true);
        })
        .catch((err) => {
          console.log(err);
          handleAlert("Something went wrong - please try again", "error");
        });
    }
  };

  return (
    <main className="register--main">
      <section className="top--banner">
        <h3>
          Don’t stop halfway - Gain full access now & dominate the property
          market!
        </h3>
      </section>
      {/* <img
        src={DealTradingImg}
        alt="Deal trading image"
        className="deal-trading-img"
      /> */}
      {/* <h3 className="mid-tagline">By the end of this programme, you’ll...</h3>
      <section className="selling-points">
        <div className="selling-point">
          <aside className="side">
            <TaskAltIcon className="online--icon" />
            <h6>Have a clear, step-by-step process to follow</h6>
          </aside>
          <p>
            Gain absolute clarity on how to source properties, secure deals, and
            structure them to earn thousands of pounds by trading them on.
            <br />
            You'll know exactly what to do at every stage.
          </p>
        </div>
        <div className="selling-point">
          <aside className="side">
            <TaskAltIcon className="online--icon" />
            <h6>Know how to set up a fully compliant deal trading business</h6>
          </aside>
          <p>
            Establish yourself as a professional deal trader, ensuring your
            business is fully compliant and operates smoothly. You’ll learn the
            right way to run your business, giving you a competitive edge.
          </p>
        </div>
        <div className="selling-point">
          <aside className="side">
            <TaskAltIcon className="online--icon" />
            <h6>Master due diligence and refurb pricing</h6>
          </aside>
          <p>
            You’ll confidently assess whether a deal is worth pursuing and know
            how to structure it for maximum profit. Additionally, you’ll learn
            how to accurately price renovations and earn project management
            fees, adding even more to your income.
          </p>
        </div>
        <div className="selling-point">
          <aside className="side">
            <TaskAltIcon className="online--icon" />
            <h6>Know how to find off-market property deals</h6>
          </aside>
          <p>
            Develop the skills to uncover the best off-market deals, allowing
            you to either build your portfolio, flip properties, or trade the
            deals you don’t want—all while making thousands of pounds with each
            deal traded.
          </p>
        </div>
        <div className="selling-point">
          <aside className="side">
            <TaskAltIcon className="online--icon" />
            <h6>Discovered how to attract the right investors</h6>
          </aside>
          <p>
            Identify and attract the ideal investors, enabling you to work
            smarter, not harder. You’ll learn how to focus on quality
            partnerships that significantly boost your earnings compared to the
            average property sourcer.
          </p>
        </div>
        <div className="selling-point">
          <aside className="side">
            <TaskAltIcon className="online--icon" />
            <h6>Gain unshakeable confidence in your abilities</h6>
          </aside>
          <p>
            With the right knowledge and a clear step-by-step process to guide
            you, you’ll be empowered to take action and start making life
            changing money within the next few months.
          </p>
        </div>
      </section> */}

      <h3 className="payment--amount">
        Pay{" "}
        <span>
          £997<span>pp + VAT</span>
        </span>{" "}
        Now
      </h3>
      <p className="payment--tagline">
        and Get the tools you need to start earning £5,000 - £10,000 per month
        within just 3–6 months!
      </p>

      <div className="attendee-form-wrapper">
        {!formSubmitted ? (
          <>
            {" "}
            <p className="payment--tagline">
              Enter your details below to proceed to payment
            </p>
            <div className="attendee-form__select-wrapper">
              <label className="attendee-form__label">
                Select number of attendees:
              </label>
              <select
                value={attendeeCount}
                onChange={handleCountChange}
                className="attendee-form__select"
              >
                {[1, 2, 3, 4].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>
            <form onSubmit={handleSubmit} className="attendee-form">
              <div className="attendee-form__grid">
                {formData.map((attendee, index) => (
                  <div key={index} className="attendee-form__card">
                    <h3 className="attendee-form__title">
                      Attendee {index + 1}
                    </h3>

                    <label className="attendee-form__label">First Name</label>
                    <input
                      type="text"
                      value={attendee.name}
                      onChange={(e) =>
                        handleInputChange(index, "name", e.target.value)
                      }
                      className="attendee-form__input"
                    />
                    {formErrors[index]?.name && (
                      <p className="attendee-form__error">
                        {formErrors[index].name}
                      </p>
                    )}

                    <label className="attendee-form__label">Last Name</label>
                    <input
                      type="text"
                      value={attendee.lastName}
                      onChange={(e) =>
                        handleInputChange(index, "lastName", e.target.value)
                      }
                      className="attendee-form__input"
                    />
                    {formErrors[index]?.lastName && (
                      <p className="attendee-form__error">
                        {formErrors[index].lastName}
                      </p>
                    )}

                    <label className="attendee-form__label">Phone</label>
                    <input
                      type="text"
                      value={attendee.phone}
                      onChange={(e) =>
                        handleInputChange(index, "phone", e.target.value)
                      }
                      className="attendee-form__input"
                    />
                    {formErrors[index]?.phone && (
                      <p className="attendee-form__error">
                        {formErrors[index].phone}
                      </p>
                    )}

                    <label className="attendee-form__label">Email</label>
                    <input
                      type="email"
                      value={attendee.email}
                      onChange={(e) =>
                        handleInputChange(index, "email", e.target.value)
                      }
                      className="attendee-form__input"
                    />
                    {formErrors[index]?.email && (
                      <p className="attendee-form__error">
                        {formErrors[index].email}
                      </p>
                    )}
                    <label className="attendee-form__label">Postcode</label>
                    <input
                      type="text"
                      value={attendee.postcode}
                      onChange={(e) =>
                        handleInputChange(index, "postcode", e.target.value)
                      }
                      className="attendee-form__input"
                    />
                    {formErrors[index]?.postcode && (
                      <p className="attendee-form__error">
                        {formErrors[index].postcode}
                      </p>
                    )}
                  </div>
                ))}
              </div>

              <div className="attendee-form__tncs">
                <FormControlLabel
                  control={<Checkbox />}
                  label="I confirm I have read and agree to the terms & conditions"
                  onChange={() => setTncs(!tncs)}
                />
                {alert && <p className="attendee-form__alert">{message}</p>}

                <Button
                  type="submit"
                  variant="outlined"
                  endIcon={<ArrowForwardIcon />}
                  className="attendee-form__submit"
                  disabled={disable}
                >
                  Continue to Payment
                </Button>
              </div>
            </form>
          </>
        ) : (
          <>
            <p className="payment--tagline">
              Enter your details below to proceed to payment
            </p>
            <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          </>
        )}
      </div>
    </main>
  );
}
